import { forwardRef, type LabelHTMLAttributes } from 'react';

import { cn } from '@/utils/cn';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  /** Accessible name for the required marker; the asterisk alone says nothing aloud. */
  requiredLabel?: string;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, children, required, requiredLabel, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('flex items-center gap-1 text-body-sm font-medium text-fg', className)}
      {...props}
    >
      {children}
      {required ? (
        <span className="text-danger" aria-hidden={!requiredLabel}>
          {requiredLabel ? <span className="sr-only">{requiredLabel}</span> : null}*
        </span>
      ) : null}
    </label>
  ),
);

Label.displayName = 'Label';
